<div class="container" (click)="$event.stopPropagation()">
  <!-- Loading state -->
  <div class="loading-state" *ngIf="isLoading">
    <span>Loading saved files...</span>
  </div>

  <!-- Error state -->
  <div class="error-state" *ngIf="error && !isLoading">
    <span>{{ error }}</span>
  </div>

  <!-- Saved files grid -->
  <div class="saved-files-content" *ngIf="!isLoading && !error" (click)="$event.stopPropagation()">
    <div class="file-groups-container">
      <div class="file-group" *ngFor="let group of fileGroups; trackBy: trackByGroupTitle">
        <div class="group-header">{{ group.title }}</div>
        <div class="files-grid" [class.history-open]="isHistoryOpen" [class.history-closed]="!isHistoryOpen">
          <div class="file-card" *ngFor="let file of group.files; trackBy: trackByFileId" (click)="onFileClick(file, $event)" (dblclick)="onFileDoubleClick(file, $event)">
            <div class="card-header">
              <span class="file-timestamp">{{ file.saved_timestamp | utcDateTime }}</span>
              <img src="assets/icons/navigator/bookmark-icon.svg"
                   alt="bookmark"
                   class="bookmark-icon"
                   (click)="onBookmarkClick(file, $event)"
                   [style.cursor]="'pointer'">
            </div>
            <div class="card-content" (click)="onFileClick(file, $event)" (dblclick)="onFileDoubleClick(file, $event)">
              <!-- Transparent overlay - shows on hover -->
              <div class="content-overlay"></div>
              <!-- Download button - shows on hover -->
              <button class="download-button"
                      (click)="onDownloadClick(file, $event)"
                      (dblclick)="$event.stopPropagation()"
                      title="Download file">
                <img src="assets/icons/navigator/download-button.svg" alt="Download" class="download-icon">
              </button>
              <!-- Chart preview for chart files -->
              <div class="chart-preview" *ngIf="isChartFile(file)">
                <img *ngIf="file.thumbnail_url && !isFileUrlExpired(file)"
                     [src]="file.thumbnail_url"
                     alt="Chart thumbnail"
                     class="chart-thumbnail"
                     loading="lazy"
                     (error)="onSavedFileThumbnailError(file)">
                <iframe *ngIf="!file.thumbnail_url && !isFileUrlExpired(file)"
                        [src]="getSafeUrl(file)"
                        class="chart-iframe"
                        (load)="removePlotlyToolbarFromIframe($event, file)"></iframe>
                <div class="file-unavailable" *ngIf="isFileUrlExpired(file)">{{ fileUnavailableMessage }}</div>
              </div>
              <!-- File icon for non-chart files -->
              <div class="file-preview" *ngIf="!isChartFile(file)">
                <img [src]="getFileIcon(file)" alt="file icon" class="file-icon" loading="lazy">
              </div>
            </div>
            <div class="card-footer">
              <div class="file-title"
                   [matTooltip]="file.saved_file_title || getFileTitle(file)"
                   [matTooltipPosition]="'above'"
                   [matTooltipClass]="'saved-file-tooltip'"
                   [matTooltipDisabled]="!isTitleTruncated(file)"
                   [class.truncated]="isTitleTruncated(file)">
                {{ file.saved_file_title || getFileTitle(file) }}
              </div>
              <div class="file-date-range" *ngIf="file.saved_file_start_date && file.saved_file_end_date">
                Date Range: {{ formatDateFromPipe(file.saved_file_start_date) }} - {{ formatDateFromPipe(file.saved_file_end_date) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="fileGroups.length === 0">
      <span>No saved files found</span>
    </div>
  </div>

  <!-- Delete Confirmation Popup -->
  <div class="delete-confirmation-overlay" *ngIf="showDeleteConfirmation" (click)="cancelDelete()">
    <div class="delete-confirmation-dialog" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <img class="warning-icon" src="assets/icons/warning-popup.svg" alt="warning"/>
        <span class="dialog-title">Remove From Files?</span>
      </div>
      <div class="dialog-content">
        <p>This file will be removed from your saved list. Do you want to continue?</p>
      </div>
      <div class="dialog-actions">
        <button class="yes-btn" (click)="confirmDelete()" [disabled]="isDeleting">
          {{ isDeleting ? 'Removing...' : 'Yes' }}
        </button>
        <button class="cancel-btn" (click)="cancelDelete()" [disabled]="isDeleting">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Image Viewer Popup -->
  <div class="image-viewer-overlay" *ngIf="showImageViewer" (click)="$event.stopPropagation()">
    <div class="image-viewer-content" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="closeImageViewer()" title="Close">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="#475258" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="image-container" *ngIf="viewerImageUrl">
        <iframe [src]="getSafeUrlForViewer(viewerImageUrl)" class="viewer-iframe" (load)="removePlotlyToolbarFromViewer($event)"></iframe>
      </div>
    </div>
  </div>
</div>
